const product = {
  product: "منتج", // translated 
  products: "منتجات", // translated 
  information: "معلومة", // translated 
  additionalInformation: "معلومات إضافية", // translated 
  contactUs: "اتصل بنا", // translated 
  contactUsText: "هل تريد تخصيص جولتك أو لديك أي أسئلة أخرى؟", // translated 
  dropUsAnEmail: "أرسل لنا بريدًا إلكترونيًا", // translated 
  viewLess: "عرض أقل", // translated 
  viewMore: "عرض المزيد", // translated 
  less: "أقل", // translated 
  more: "أكثر", // translated 
  highlights: "يسلط الضوء", // translated 
  inclusions: "الادراج", // translated 
  exclusions: "الاستثناءات", // translated 
  pleaseWait: "انتظر من فضلك...", // translated 
  tourType: "نوع الجولة", // translated 
  search: "يبحث", // translated 
  available: "متاح", // translated 
  availableTours: "الجولات المتاحة", // translated 
  sortBy: "ترتيب حسب", // translated 
  priceLowToHigh: "السعر من الارخص للاعلى", // translated 
  priceHighToLow: "السعر الاعلى الى الادنى", // translated 
  mostPopular: "الأكثر شعبية", // translated 
  roomOnly: "غرفة فقط", // translated 
  bedAndBreakfast: "سرير و فطور", // translated 
  halfBoard: "نصف إقامة", // translated 
  fullBoard: "ممتلئ", // translated 
  allInclusive: "الجميع مشمول", // translated 
  viewDetails: "عرض التفاصيل", // translated 
  close: "يغلق", // translated 
  at: "في", // At dat, // translated 
  person: "شخص", // translated 
  cancellationPolicy: "سياسة الإلغاء", // translated 
  cancellationIs: "الإلغاء هو", // translated 
  to: "ل", // translated 
  bookingRemarks: "ملاحظات الحجز", // translated 
  totalPrice: "السعر الكلي", // translated 
  back: "خلف", // translated 
  bookNow: "احجز الآن", // translated 
  minutes: "دقائق", // translated 
  visitDuration: "مدة الزيارة", // translated 
  itinerary: "مسار الرحلة", // translated 
  airportToHotel: "المطار إلى الفندق", // translated 
  hotelToAirport: "الفندق إلى المطار", // translated 
  details: "تفاصيل", // translated 
  servicesDetails: "تفاصيل الخدمات", // translated 
  services: "خدمات", // translated 
  day: "يوم", // translated 
  next: "التالي", // translated 
  nextStep: "الخطوة التالية", // translated 
  skip: "يتخطى", // translated 
  remarks: "ملاحظات", // translated 
  optional: "خياري", // translated 
  guests: "ضيوف", // translated 
  payment: "قسط", // translated 
  pickup: "يلتقط", // translated 
  featuredPackage: "الحزمة المميزة", // translated 
  flights: "الرحلات الجوية", // translated 
  accommodation: "إقامة", // translated 
  transfers: "التحويلات", // translated 
  tours: "جولات", // translated 
  experiences: "خبرة", // translated 
  featuredTour: "جولة مميزة", // translated 
  From: "من", // translated 
  Accommodation: "إقامة", // translated 
  approxDuration: "تقريبا. مدة", // translated 
  travellerInformation: "معلومات المسافر", // translated 
  bookingOverview: "نظرة عامة على الحجز", // translated 
  checkout: "الدفع", // translated 
  paymentFailed: "عملية الدفع فشلت", // translated 
  paymentSuccess: "الدفع الناجح", // translated 
  night: "ليلة", // translated 
  nights: "ليالي", // translated 
  viewEscapes: "شاهد الهروب", // translated 
  viewExperience: "عرض الخبرة", // translated 
  escapeType: "نوع الهروب", // translated 
  adultsOnly: "للبالغين فقط", // translated 
  totalDuration: "المدة الإجمالية", // translated 
  options: "خيارات", // translated 
  departingAirport: "مطار المغادرة", // translated 
  childrenAreNotAllowedInThisTour: "لا يسمح للأطفال في هذه الجولة", // translated 
};



export default product;
